import React, { useState, useCallback } from "react";
import "../../styles/produs/NormalizedCarImage.css";

const NormalizedCarImage = ({
  src,
  alt = "",
  className = "",
  variant = "card",
  onClick,
}) => {
  const [status, setStatus] = useState("loading");
  const [orientation, setOrientation] = useState("landscape");

  const handleLoad = useCallback((e) => {
    const { naturalWidth, naturalHeight } = e.currentTarget;
    setOrientation(naturalHeight > naturalWidth ? "portrait" : "landscape");
    setStatus("loaded");
  }, []);

  if (!src || status === "error") {
    return (
      <div className={`nci nci--empty nci--${variant} ${className}`.trim()}>
        <span>Fără imagine</span>
      </div>
    );
  }

  return (
    <div
      className={`nci nci--${variant} nci--${orientation} ${className}`.trim()}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <img
        className={`nci__img${status === "loaded" ? " is-loaded" : ""}`}
        src={src}
        alt={alt}
        loading="lazy"
        draggable={false}
        onLoad={handleLoad}
        onError={() => setStatus("error")}
      />
    </div>
  );
};

export default NormalizedCarImage;
